import axios from 'axios';
import api from './api';

// GenericFormDrawer.uploadSchemaFiles'tan çıkarılan ortak akış:
// presign → R2'ye ham PUT (kendi api instance'ımız DEĞİL) → file_url.
// `purpose` sunucuda görünürlük kovasına eşlenir; verilmezse Private varsayılır.
export const presignAndUploadFile = async (file, purpose) => {
  const purposeParam = purpose ? `&purpose=${encodeURIComponent(purpose)}` : '';
  const presignRes = await api.post(
    `/v1/storage/presign?fileName=${encodeURIComponent(file.name)}&mimeType=${encodeURIComponent(file.type)}${purposeParam}`
  );
  const { upload_url, file_url } = presignRes.data;
  try {
    await axios.put(upload_url, file, {
      headers: { 'Content-Type': file.type || 'application/octet-stream' },
    });
  } catch (err) {
    // Ham R2 adımı interceptor'dan hiç geçmez (api instance değil) — çağıran
    // sayfa bu bacağın hatasını ayırt edip kendi mesajını gösterebilsin.
    if (err && typeof err === 'object') err.isRawUploadError = true;
    throw err;
  }
  return file_url;
};
